import * as ObjectActions from '../actions/object.actions';
export type Actions = ObjectActions.Actions;

export function objectReducer(state: Object, action: Actions) {
  switch (action.type) {
    case ObjectActions.SET_OBJECT:
      state = action.payload;
      return state;
    case ObjectActions.DISMIS_OBJECT:
      state = null;
      return state;
    default:
      return state;
  }
}
